import React from "react";
import LoadingDots from "../LoadingDots";
import "./LoadingAnimation.scss";

const LoadingAnimation = () => (
    <div className="payment-iframe-loading-animation">
        {/* Errors are thrown because the component does not have default values for optional props */}
        {/* This is being ignored as it is a very old component that is used in many different places */}
        {/* @ts-ignore  */}
        <LoadingDots center />
    </div>
);
export default LoadingAnimation;
